import { render, staticRenderFns } from "./receipt-analysis.vue?vue&type=template&id=0b15c9ef&scoped=true&"
import script from "./receipt-analysis.vue?vue&type=script&lang=ts&"
export * from "./receipt-analysis.vue?vue&type=script&lang=ts&"
import style0 from "./receipt-analysis.vue?vue&type=style&index=0&id=0b15c9ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b15c9ef",
  null
  
)

export default component.exports